/**
 * Reusable CSV export: builds a UTF-8 (BOM-prefixed, for Excel) CSV blob from
 * columns + rows and triggers a browser download. Generic on purpose — any
 * list page can call this with its own columns/rows instead of re-copying
 * the blob/anchor-download plumbing.
 */
export interface CsvExportOptions {
  /** Header row labels. */
  columns: string[];
  /** Body rows. */
  rows: Array<Array<string | number>>;
  /** Download filename (should end in .csv). */
  filename: string;
}

function csvEsc(v: string | number): string {
  const s = String(v ?? '');
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function exportCsv(o: CsvExportOptions): void {
  const lines = [o.columns, ...o.rows].map((r) => r.map(csvEsc).join(','));
  const blob = new Blob(['﻿' + lines.join('\n')], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = o.filename;
  a.click();
  URL.revokeObjectURL(url);
}
